function dispatchEvent(el, type) {
  let evt = document.createEvent('HTMLEvents')
  evt.initEvent(type, true, true)
  el.dispatchEvent(evt)
}

const Trim = {
  inserted: el => {
    let inputEle = el.querySelector("input");

    const handler = function (event) {

      const newVal = event.target.value.trim()
      if (event.target.value != newVal) {
        event.target.value = newVal
        dispatchEvent(inputEle, 'input')
      }
    }
    el.inputEle = inputEle
    el._blurHandler = handler
    inputEle.addEventListener('blur', handler)
  },
  unbind(el) {
    const {inputEle} = el
    inputEle.removeEventListener('blur', el._blurHandler)
  }
}

export default {
  install(Vue) {

    Vue.directive('inputTrim', Trim)
  }
}



// WEBPACK FOOTER //
// ./src/utils/inputTrim.js